import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, TransitionGroup as _TransitionGroup, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex w-full h-full pr-10 gap-6 items-center" }
const _hoisted_2 = { class: "flex items-center pr-2 gap-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 items-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Back to conversations"),
  /*#__PURE__*/_createElementVNode("div", { class: "rounded-md button-bg rounded-md px-1 py-0.5" }, " Esc ")
], -1)
const _hoisted_4 = { class: "text-sm text-gray-theme-600 font-medium whitespace-nowrap overflow-hidden overflow-ellipsis" }
const _hoisted_5 = { class: "ml-auto flex items-center gap-4 flex-shrink-0" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-center absolute left-0 right-0 bottom-0 top-0"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 items-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mark all messages read"),
  /*#__PURE__*/_createElementVNode("div", { class: "rounded-md button-bg rounded-md px-1 py-0.5" }, " U ")
], -1)
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center absolute left-0 right-0 bottom-0 top-0"
}
const _hoisted_9 = { class: "flex gap-3 items-center" }
const _hoisted_10 = { class: "rounded-md button-bg rounded-md px-1 py-0.5" }
const _hoisted_11 = {
  key: 0,
  class: "h-7 w-7 rounded-full absolute top-0 bottom-0 left-0 right-0 bg-white bg-opacity-50 flex items-center justify-center"
}
const _hoisted_12 = { class: "px-10 justify-between text-13 bg-gray-theme-300 flex-shrink-0 flex items-center h-10 text-xs sticky top-0 z-1 text-gray-theme-500 border-solid border-0 border-b shadow-sm" }
const _hoisted_13 = { class: "flex items-center gap-2" }
const _hoisted_14 = { class: "rounded-md inline-flex button-bg rounded-md px-1 py-0.5" }
const _hoisted_15 = { class: "flex gap-3 items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "capitalize" }, "Open command palette for bulk actions", -1)
const _hoisted_17 = { class: "rounded-md button-bg rounded-md px-1 py-0.5" }
const _hoisted_18 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "capitalize" }, "Load 30 conversations more")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "capitalize" }, "Refresh"),
  /*#__PURE__*/_createElementVNode("div", { class: "rounded-md button-bg rounded-md px-1 py-0.5" }, " R ")
], -1)
const _hoisted_21 = {
  key: 0,
  class: "absolute top-12 left-0 bottom-0 right-0 flex flex-col gap-4 pt-4 items-center justify-center"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-theme-500" }, " Loading messages...", -1)
const _hoisted_23 = {
  key: 1,
  class: "flex flex-col items-center gap-4 pt-10"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl text-gray-theme-500" }, " You have no messages with this contact. ", -1)
const _hoisted_25 = {
  key: 0,
  class: "pl-3 text-sm justify-center mt-2 flex"
}
const _hoisted_26 = { class: "h-50 flex flex-col justify-center gap-4 bg-gray-theme-300 rounded-md oveflow-hidden w-full" }
const _hoisted_27 = { class: "text-lg whitespace-nowrap overflow-hidden overflow-ellipsis px-4 text-center" }

import { useArrowEvents } from '@/command-palette';
import {
	DropdownWithTooltip,
	BorderedButton,
	Dialog,
	SvgIcon,
	Tooltip,
	UiAvatar,
	UiLoader,
	useUiState
} from '@/ui-kit';
import { composeGuards, detectOs } from '@/utils';
import {
	useActiveElement,
	useMagicKeys,
	useToggle,
	whenever,
	onClickOutside
} from '@vueuse/core';
import {
	onMounted,
	computed,
	onBeforeUnmount,
	ref,
	watch
} from 'vue';
import {
	onBeforeRouteLeave,
	onBeforeRouteUpdate,
	useRoute,
	useRouter
} from 'vue-router';
import { useComposeInput } from '../compose-input';
import {
	BaseMessage,
	ConversationMessage,
	useConversations,
	useMessages,
	useShowLoadingMessage
} from '../composition';
import MessagePreview from './components/MessagePreview.vue';
import { isSelectedLeadValid } from './guards/is-selected-lead-valid-guard';
import { useConversationsActions } from './use-conversations-action';
import { ElInfiniteScroll as vInfiniteScroll } from 'element-plus/lib';
import { useTeams } from '@/team';
import { useCommandPaletteActions } from '@/command-palette/use-command-palette-actions';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConversationDetails',
  setup(__props) {

const {
	loadMessages,
	groupMessageCreatedAt,
	messages,
	setSelectedMessage,
	selectedMessage,
	selectedMessageIdx,
	isLoaded,
	conversationId,
	cancelLoad,
	hasMore,
	page,
	isSelectedMessage,
	setSelectedMessages,
	selectedMessages,
	refreshMessages,
	totalItems
} = useMessages();
const {
	selectedConversation,
	markConversationAsRead,
	markAsClosed,
	markAsOpened,
	isConversationUpdating,
	detachTeamMember,
	assignTeamMember
} = useConversations();
const {
	setConversationActions,
	setMessageActions,
	setBulkMessageActions
} = useConversationsActions();
const { setIsOpened } = useCommandPaletteActions();
const ui = useUiState();
const route = useRoute();
const router = useRouter();
const { escape, space, a, current, backspace } =
	useMagicKeys();
const {
	onArrowDown,
	onArrowUp,
	onArrowLeft,
	onArrowRight
} = useArrowEvents(undefined, 'externalComposeInput');
const { toggleIsOpened } = useComposeInput();
const [togglingClose, setTogglingClose] = useToggle();
const { showMessage } = useShowLoadingMessage();

const activeElement = useActiveElement();

whenever(
	() => {
		const tagName = activeElement.value?.tagName;
		return (
			backspace.value &&
			ui.isNoDialogAndDropdown &&
			tagName !== 'INPUT' &&
			tagName !== 'TEXTAREA' &&
			tagName !== 'SELECT' &&
			!activeElement.value?.classList.contains(
				'ck'
			) &&
			!activeElement.value?.getAttribute(
				'contenteditable'
			)
		);
	},
	() => {
		router.push({ name: 'ConversationsV2' });
	}
);

whenever(
	() =>
		current.size === 2 &&
		current.has('shift') &&
		current.has('r') &&
		isLoaded.value &&
		!moreLoading.value &&
		selectedConversation.value,
	() => {
		refreshMessages(selectedConversation.value!.id);
	}
);

function selectMessage(message: BaseMessage) {
	setSelectedMessage(message);

	if (isActiveElementButton.value) {
		headerButtons.value[actionFocusedIdx.value]?.blur();
	}

	if (selectedMessages.value.size) {
		setBulkMessageActions();
	} else {
		setMessageActions();
	}
}

const itemsRef = ref<
	Array<InstanceType<typeof MessagePreview>>
>([]);
const scrolling = ref(true);

const isSelectedMessageAndUIStateClosed = computed(() => {
	return (
		ui.isNoDialogAndDropdown && !!selectedMessage.value
	);
});

const isUnread = computed(
	() =>
		selectedConversation.value &&
		selectedConversation.value.unread_count > 0
);

const [moreLoading, toggleMoreLoading] = useToggle();
const [markingAsRead, toggleMarkingAsRead] = useToggle();

const currentOs = detectOs();
const isMacOs = currentOs === 'MacOS';

const hovered = computed(
	() => ui.selectedBlockName === 'center'
);
const headerRef = ref();

whenever(
	() => {
		return (
			escape.value &&
			ui.isNoDialogAndDropdown &&
			hovered.value &&
			selectedMessages.value.size
		);
	},
	() => {
		setSelectedMessages([]);
	}
);

onArrowDown((data) => {
	if (!messages.value.length || !hovered.value) {
		return;
	}

	scrolling.value = true;
	const nextIdx = selectedMessageIdx.value + 1;
	const nextMessage = messages.value[nextIdx];
	const lastIdx = messages.value.length - 1;

	if (
		!selectedMessage.value ||
		isActiveElementButton.value
	) {
		selectMessage(messages.value[0]);
		return itemsRef.value[0].focusItem(false);
	}

	const currentIdx = messages.value.findIndex(
		(msg) => msg.id === selectedMessage.value!.id
	);

	const ctrl = isMacOs ? data.metaKey : data.ctrlKey;

	if (ctrl) {
		if (currentIdx === lastIdx) {
			return;
		}

		if (data.shiftKey) {
			const msgs = messages.value.slice(
				currentIdx,
				lastIdx + 1
			);
			setSelectedMessages(msgs);
		}
		selectMessage(messages.value[lastIdx]);
		return itemsRef.value[lastIdx].focusItem(false);
	}

	if (data.shiftKey) {
		const values = [...selectedMessages.value.values()];

		if (!values.length) {
			const msgs = messages.value.slice(
				currentIdx,
				currentIdx + 2
			);
			setSelectedMessages(msgs);
			selectMessage(messages.value[currentIdx + 1]);
			return itemsRef.value[
				currentIdx + 1
			].focusItem();
		}

		const firstIdx = messages.value.findIndex(
			(msg) => msg.id === values[0]
		);
		const lastIdx = messages.value.findIndex(
			(msg) => msg.id === values[values.length - 1]
		);

		if (!messages.value[lastIdx + 1]) {
			return;
		}

		const msgs = messages.value.slice(
			firstIdx,
			lastIdx + 2
		);

		setSelectedMessages(msgs);
		selectMessage(messages.value[lastIdx + 1]);
		return itemsRef.value[lastIdx + 1].focusItem();
	}

	setSelectedMessages([]);

	if (!nextMessage) {
		selectMessage(messages.value[0]);
		return itemsRef.value[0]?.focusItem(false);
	}

	selectMessage(nextMessage);
	return itemsRef.value[nextIdx]?.focusItem(false);
});

onArrowUp((data) => {
	if (
		!messages.value.length ||
		!hovered.value ||
		isActiveElementButton.value
	) {
		return;
	}

	scrolling.value = true;
	const lastIdx = messages.value.length - 1;
	const prevIdx = selectedMessageIdx.value - 1;
	const prevMessage = messages.value[prevIdx];

	if (!selectedMessage.value) {
		selectMessage(messages.value[lastIdx]);
		return itemsRef.value[lastIdx].focusItem(false);
	}

	const currentIdx = messages.value.findIndex(
		(m) => m.id === selectedMessage.value!.id
	);

	if (currentIdx === 0) {
		headerButtons.value[
			actionFocusedIdx.value
		]?.focus();
		return;
	}

	const ctrl = isMacOs ? data.metaKey : data.ctrlKey;

	if (ctrl) {
		if (currentIdx === 0) {
			return;
		}

		if (data.shiftKey) {
			const msgs = messages.value.slice(
				0,
				currentIdx + 1
			);
			setSelectedMessages(msgs);
		} else {
			selectMessage(messages.value[0]);
		}
		return itemsRef.value[0].focusItem(false);
	}

	if (data.shiftKey) {
		const values = [...selectedMessages.value.values()];

		if (!values.length) {
			const msgs = messages.value.slice(
				currentIdx - 1,
				currentIdx + 1
			);
			setSelectedMessages(msgs);
			selectMessage(messages.value[currentIdx - 1]);
			return itemsRef.value[
				currentIdx - 1
			].focusItem();
		}

		let firstIdx = messages.value.findIndex(
			(msg) => msg.id === values[0]
		);
		let lastIdx = messages.value.findIndex(
			(msg) => msg.id === values[values.length - 1]
		);

		if (!messages.value[firstIdx - 1]) {
			return;
		}

		const msgs = messages.value.slice(
			firstIdx - 1,
			lastIdx + 1
		);

		setSelectedMessages(msgs);
		selectMessage(messages.value[firstIdx - 1]);
		return itemsRef.value[firstIdx - 1].focusItem();
	}

	setSelectedMessages([]);

	if (!prevMessage) {
		selectMessage(messages.value[lastIdx]);
		return itemsRef.value[lastIdx]?.focusItem(false);
	}

	selectMessage(prevMessage);
	return itemsRef.value[prevIdx]?.focusItem();
});

function onConvMouseOver(message: ConversationMessage) {
	if (scrolling.value || ui.isDropdownOpened) {
		return;
	}

	selectMessage(message);
}

function onMouseOut() {
	if (scrolling.value || !ui.isNoDialogAndDropdown) {
		return;
	}

	setSelectedMessage(null);
	setConversationActions();
}

if (
	!isLoaded.value ||
	route.params.leadId.toString() !== conversationId.value
) {
	loadMessages(route.params.leadId.toString());
}

onBeforeRouteLeave((to) => {
	if (to.name !== 'MessageDetails') {
		setSelectedMessage(null);
	}
});

setConversationActions(true);

watch(selectedConversation, () => setConversationActions());

onBeforeUnmount(() => {
	cancelLoad();
});

const [isLoading, setIsLoading] = useToggle();
const loadingLeadName = ref('');

onBeforeRouteUpdate(
	composeGuards(
		(to, from, next) => {
			loadingLeadName.value =
				(to.params.leadName as string) || '';
			setIsLoading(true);
			next();
		},
		isSelectedLeadValid,
		(to, from, next) => {
			setIsLoading(false);
			loadMessages(to.params.leadId.toString());
			next();
		}
	)
);

async function load() {
	if (
		!isLoaded.value ||
		moreLoading.value ||
		!hasMore.value
	) {
		return;
	}
	toggleMoreLoading(true);
	await loadMessages(
		route.params.leadId.toString(),
		page.value + 1
	);
	toggleMoreLoading(false);
}

async function toggleOpened() {
	if (!selectedConversation.value) {
		return;
	}

	setTogglingClose(true);

	if (selectedConversation.value.is_closed) {
		showMessage('Marking conversation as opened...');
		await markAsOpened(selectedConversation.value);
		showMessage('');
	} else if (selectedConversation.value.is_opened) {
		showMessage('Marking conversation as closed...');
		await markAsClosed(selectedConversation.value);
		showMessage('');
	}

	setTogglingClose(false);
}

const { allItems } = useTeams();

const assignActions = computed(() => {
	return [
		{ title: 'Unassigned', value: -1 },
		...allItems.value.map((item) => ({
			title: item.name,
			value: item.id
		}))
	];
});

const isUpdating = computed(
	() =>
		selectedConversation.value &&
		isConversationUpdating(
			selectedConversation.value.id
		)
);

function toggleAssign(id: number) {
	if (!selectedConversation.value) {
		return;
	}

	if (
		id === -1 &&
		!selectedConversation.value.assigned?.length
	) {
		return;
	}

	if (id === -1) {
		return detachTeamMember(
			selectedConversation.value,
			selectedConversation.value.assigned[0]
		);
	}

	const teamMember = allItems.value.find(
		(item) => item.id === id
	);

	if (!teamMember) {
		return;
	}

	return assignTeamMember(
		selectedConversation.value,
		teamMember
	);
}

function onEnter() {
	setSelectedMessages([]);
}

function onMouseMove() {
	if (!scrolling.value) {
		return;
	}

	scrolling.value = false;
}

const ctrlKey = isMacOs ? '⌘' : 'Ctrl';

async function markAsRead() {
	if (!selectedConversation.value) {
		return;
	}

	showMessage('Marking conversation as read...');
	toggleMarkingAsRead(true);
	await markConversationAsRead(
		selectedConversation.value
	);
	showMessage('');
	toggleMarkingAsRead(false);
}

const actionFocusedIdx = ref(0);

const isActiveElementButton = computed(() => {
	return headerButtons.value.some(
		(el) => el === activeElement.value
	);
});

const headerButtons = computed<HTMLButtonElement[]>(() => {
	const buttons =
		headerRef.value?.querySelectorAll('button');
	return buttons ? [...buttons] : [];
});

const containerRef = ref<HTMLDivElement>();

onMounted(() => {
	if (hovered.value) {
		actionFocusedIdx.value = 0;
		headerButtons.value[0].focus();
	}
});

onClickOutside(containerRef, () => {
	if (hovered.value) {
		actionFocusedIdx.value = 0;
		activeElement.value?.blur();
		ui.setSelectedBlock('');
	}
});

onArrowLeft(() => {
	if (hovered.value) {
		if (
			actionFocusedIdx.value === 0 ||
			!isActiveElementButton.value
		) {
			actionFocusedIdx.value = 0;
			headerButtons.value[0]?.blur();
			return ui.setSelectedBlock('sidebar');
		}

		actionFocusedIdx.value = actionFocusedIdx.value - 1;
		headerButtons.value[
			actionFocusedIdx.value
		]?.focus();
	}

	if (ui.selectedBlockName === 'right') {
		actionFocusedIdx.value = 2;
		headerButtons.value[2]?.focus();
		return ui.setSelectedBlock('center');
	}
});

onArrowRight(() => {
	if (ui.selectedBlockName === 'center') {
		if (
			actionFocusedIdx.value === 2 ||
			!isActiveElementButton.value
		) {
			actionFocusedIdx.value = 0;
			if (
				activeElement.value &&
				containerRef.value?.contains(
					activeElement.value
				)
			) {
				activeElement.value.blur();
			}
			return ui.setSelectedBlock('right');
		}

		actionFocusedIdx.value = actionFocusedIdx.value + 1;
		headerButtons.value[
			actionFocusedIdx.value
		]?.focus();
	}

	if (ui.selectedBlockName === 'sidebar') {
		actionFocusedIdx.value = 0;
		headerButtons.value[0]?.focus();
		return ui.setSelectedBlock('center');
	}
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "containerRef",
    ref: containerRef,
    class: _normalizeClass(["flex w-full flex-col h-full relative", { 'shadow-2xl': _unref(hovered) }]),
    onMouseenter: _cache[5] || (_cache[5] = ($event: any) => {
			_unref(ui).setSelectedBlock('center');
			onEnter();
		}),
    onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_unref(ui).setSelectedBlock('')))
  }, [
    _createElementVNode("header", {
      ref_key: "headerRef",
      ref: headerRef,
      class: "flex gap-2 h-15 flex-shrink-0 pl-10 items-center justify-between font-light"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Tooltip), { placement: "bottom" }, {
          popper: _withCtx(() => [
            _hoisted_3
          ]),
          default: _withCtx(() => [
            _createVNode(_component_RouterLink, { to: { name: 'ConversationsV2' } }, {
              default: _withCtx(() => [
                _createVNode(_unref(BorderedButton), null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_unref(SvgIcon), {
                        name: "BackArrowIcon",
                        class: "h-3 w-3"
                      }),
                      _createTextVNode(" Back ")
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(selectedConversation)?.lead.name), 1),
        _createElementVNode("div", _hoisted_5, [
          (_unref(isUnread))
            ? (_openBlock(), _createBlock(_unref(Tooltip), { key: 0 }, {
                popper: _withCtx(() => [
                  _hoisted_7
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(BorderedButton), {
                    disabled: _unref(markingAsRead),
                    class: "relative",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (markAsRead()))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex items-center pr-2 gap-2", {
									'opacity-0':
										_unref(markingAsRead)
								}])
                      }, " Mark all read ", 2),
                      (_unref(markingAsRead))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_unref(UiLoader))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(Tooltip), null, {
            popper: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", null, _toDisplayString(_unref(selectedConversation)?.is_closed
										? 'Mark as open'
										: 'Mark as closed'), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(selectedConversation)?.is_closed
											? 'O'
											: 'D'), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(BorderedButton), {
                disabled: _unref(togglingClose),
                onClick: toggleOpened,
                class: "relative"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex items-center pr-2 gap-2", {
									'opacity-0':
										_unref(togglingClose)
								}])
                  }, [
                    _createVNode(_unref(SvgIcon), {
                      name: "DoneIcon",
                      class: "h-3 w-3"
                    }),
                    _createTextVNode(" " + _toDisplayString(_unref(selectedConversation)?.is_closed
										? 'Mark as open'
										: 'Mark as closed'), 1)
                  ], 2),
                  (_unref(togglingClose))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_unref(UiLoader))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }),
          (_unref(selectedConversation))
            ? (_openBlock(), _createBlock(_unref(DropdownWithTooltip), {
                key: 1,
                tooltipTitle: 
							!_unref(selectedConversation).assigned ||
							!_unref(selectedConversation)
								.assigned?.[0]
								? 'Assign to'
								: `Assigned to
											${_unref(selectedConversation).assigned?.[0]?.name}`
						,
                "dropdown-placement": 'bottom',
                openOnKey: 'A',
                inputTitle: "Assign to",
                withCheck: "",
                modelValue: 
							_unref(selectedConversation)
								?.assigned?.[0]?.id || -1
						,
                actions: _unref(assignActions),
                "onUpdate:modelValue": toggleAssign,
                disabled: _unref(isUpdating)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: _normalizeClass(["text-gray-theme-400 flex items-center transition relative outline-none", [
								!_unref(selectedConversation)
									.assigned?.length
									? 'opacity-50 hover:opacity-100 focus:opacity-100'
									: 'opacity-75 hover:opacity-100 focus:opacity-100'
							]])
                  }, [
                    (_unref(isUpdating))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_unref(UiLoader), { isSmall: "" })
                        ]))
                      : _createCommentVNode("", true),
                    (
									!_unref(selectedConversation)
										.assigned?.length
								)
                      ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                          key: 1,
                          name: "EmptyUserIcon",
                          class: "!h-7 !w-7"
                        }))
                      : (_openBlock(), _createBlock(_unref(UiAvatar), {
                          key: 2,
                          withShadow: "",
                          class: "!h-7 !w-7 !text-xxs",
                          avatar: 
									_unref(selectedConversation)
										.assigned[0]?.avatar
										?.path
								,
                          name: 
									_unref(selectedConversation)
										.assigned[0]?.name
								
                        }, null, 8, ["avatar", "name"]))
                  ], 2)
                ]),
                _: 1
              }, 8, ["tooltipTitle", "modelValue", "actions", "disabled"]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("span", null, [
          _createTextVNode("Messages "),
          (_unref(selectedMessages).size)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" | " + _toDisplayString(_unref(selectedMessages).size) + " selected ", 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        (_unref(selectedMessages).size)
          ? (_openBlock(), _createBlock(_unref(Tooltip), { key: 0 }, {
              popper: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(ctrlKey)) + " K ", 1)
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(BorderedButton), {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(setIsOpened)(true))),
                  class: "!h-6 flex items-center gap-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Bulk Actions "),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(ctrlKey)) + " K ", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (_unref(isLoaded))
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("span", null, " Showing " + _toDisplayString(_unref(messages).length) + " from " + _toDisplayString(_unref(totalItems)), 1),
            (_unref(hasMore))
              ? (_openBlock(), _createBlock(_unref(Tooltip), {
                  key: 0,
                  class: "flex-shrink-0",
                  disabled: !_unref(isLoaded) || _unref(moreLoading)
                }, {
                  popper: _withCtx(() => [
                    _hoisted_19
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(BorderedButton), {
                      disabled: !_unref(isLoaded) || _unref(moreLoading),
                      class: "flex-shrink-0 !h-6 w-24 flex items-center justify-center gap-2",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (load()))
                    }, {
                      default: _withCtx(() => [
                        (!_unref(moreLoading))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" Load more ")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" Loading... "),
                              _createVNode(_unref(UiLoader), { isSmall: "" })
                            ], 64))
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            _createVNode(_unref(Tooltip), {
              disabled: !_unref(isLoaded) || _unref(moreLoading)
            }, {
              popper: _withCtx(() => [
                _hoisted_20
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(BorderedButton), {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (
							_unref(refreshMessages)(
								_unref(selectedConversation).id
							)
						)),
                  disabled: !_unref(isLoaded) || _unref(moreLoading),
                  class: "!h-6 flex-shrink-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SvgIcon), {
                      name: "refresh",
                      class: _normalizeClass(["h-3 w-3", {
								'rotation-animation':
									!_unref(isLoaded) || _unref(moreLoading)
							}])
                    }, null, 8, ["class"])
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["disabled"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_unref(isLoaded))
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(_unref(UiLoader))
        ]))
      : _createCommentVNode("", true),
    (_unref(isLoaded) && !_unref(messages).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _hoisted_24,
          _createVNode(_unref(BorderedButton), {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(toggleIsOpened)(true)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Compose new message")
            ]),
            _: 1
          })
        ]))
      : _withDirectives((_openBlock(), _createBlock(_TransitionGroup, {
          key: 2,
          name: "list",
          tag: "div",
          class: "overflow-y-auto h-full flex flex-col pb-4 scrollbar",
          onMousemove: onMouseMove,
          "infinite-scroll-distance": 40
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messages), (message, i) => {
              return (_openBlock(), _createBlock(MessagePreview, {
                key: i,
                onMouseenter: ($event: any) => (onConvMouseOver(message)),
                onClick: ($event: any) => (_unref(setSelectedMessage)(message)),
                ref_for: true,
                ref_key: "itemsRef",
                ref: itemsRef,
                isFocused: 
						(((_unref(hovered) ||
							_unref(ui).activeDialogName ===
								'commandPalette' ||
							_unref(ui).activeDialogName ===
								'moveMessageDialog') &&
							_unref(selectedMessage)?.id ===
								message.id) ||
							_unref(isSelectedMessage)(
								message.id
							)) &&
						!_unref(isActiveElementButton)
					,
                isScrolling: scrolling.value,
                message: message
              }, null, 8, ["onMouseenter", "onClick", "isFocused", "isScrolling", "message"]))
            }), 128)),
            (_unref(moreLoading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createTextVNode(" Loading more messages "),
                  _createVNode(_unref(UiLoader), { class: "ml-2" })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })), [
          [_unref(vInfiniteScroll), load]
        ]),
    _createVNode(_unref(Dialog), {
      preventDefaultClose: true,
      modelValue: _unref(isLoading)
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("span", _hoisted_27, [
            _createTextVNode(" Loading conversation "),
            (loadingLeadName.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("with " + _toDisplayString(loadingLeadName.value), 1)
                ], 64))
              : _createCommentVNode("", true),
            _createTextVNode("... ")
          ]),
          _createVNode(_unref(UiLoader), { class: "mx-auto" })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 34))
}
}

})